import UpdateRefCodeForm from "pages/Orders/OrderDetail/OrderDetailPage/UpdateRefCodeForm";
import PropTypes from "prop-types";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const UpdateRefCodeModal = forwardRef((props, ref) => {
  const { handleOnSuccessInsertOrderRefCode } = props;
  const [modalRefCodeOpen, setModalRefCodeOpen] = useState(false);
  const [data, setData] = useState({
    orderId: null,
    orderRefCode: null,
    isUpdateExist: false,
  });
  const { t } = useTranslation(["myOrders"]);

  useImperativeHandle(ref, () => ({
    openModal: ({ orderId, orderRefCode, isUpdateExist = false }) => {
      setData({
        orderId,
        orderRefCode,
        isUpdateExist,
      });
      setModalRefCodeOpen(true);
    },
  }));

  const onSuccessInsertOrderRefCode = () => {
    setModalRefCodeOpen(false);
    if (handleOnSuccessInsertOrderRefCode) {
      handleOnSuccessInsertOrderRefCode();
    }
  };

  return (
    <div>
      <Modal
        isOpen={modalRefCodeOpen}
        autoFocus={true}
        toggle={() => setModalRefCodeOpen(!modalRefCodeOpen)}
      >
        <div className="modal-content">
          <ModalHeader>{t("order:title.update_ref_code")}</ModalHeader>
          <ModalBody>
            <UpdateRefCodeForm
              orderId={data.orderId}
              onSuccess={onSuccessInsertOrderRefCode}
              refCode={data.orderRefCode}
              isUpdateExist={data.isUpdateExist}
            />
          </ModalBody>
        </div>
      </Modal>
    </div>
  );
});

UpdateRefCodeModal.propTypes = {
  handleOnSuccessInsertOrderRefCode: PropTypes.any,
};

export default UpdateRefCodeModal;
